import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import keys from './keys';
import userKeys from '../user/keys';
import useApiMutation from '../useApiMutation';
import featuresKeys from '../features/keys';

const useDeleteEpisode = () => {
  const queryClient = useQueryClient();
  const { showId, networkId } = useParams();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId, episodeId }) => `/shows/${showId}/episodes/${episodeId}`,
    method: 'DELETE',
    onSuccess: (newEpisodeData) => {
      queryClient.invalidateQueries(userKeys.me);
      queryClient.invalidateQueries(keys(newEpisodeData.show).episodes);
      queryClient.invalidateQueries(
        featuresKeys.list({
          networkId,
          showId,
        })
      );
    },
  });

  return {
    deleteEpisode: mutation.mutate,
    isDeleteEpisodeLoading: mutation.isLoading,
    isDeleteEpisodeError: mutation.isError,
    isDeleteEpisodeSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useDeleteEpisode;
